import rentObjectBookingAttachmentsService from "@/services/rentObjectBookingAttachmentsService";

const state = () => ({
  all: [],
  single: null
});

const actions = {
  async create({ dispatch }, formData) {
    try {
      await rentObjectBookingAttachmentsService.create(formData);
      dispatch(
        "common/showSuccess",
        "Dokument wurde erfolgreich zum Verlauf hinzugefügt.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Dokument konnte nicht gespeichert werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async findAll({ commit, dispatch }, formData) {
    commit("setAll", []);
    try {
      const res = await rentObjectBookingAttachmentsService.findAll(formData);
      commit("setAll", res.data);
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Dokuments für diese Buchung konnten nicht geladen werden." + error,
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async getAttachement({ dispatch }, formData) {
    try {
      const res = await rentObjectBookingAttachmentsService.getAttachement(formData);
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Dokument-Datei für diese Buchung konnte nicht geladen werden." + error,
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async delete({ dispatch }, { id }) {
    try {
      await rentObjectBookingAttachmentsService.delete({ id });
      dispatch(
        "common/showSuccess",
        "Dokument wurde erfolgreich gelöscht.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Dokument für diese Buchung konnte nicht gelöscht werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
};

const getters = {
};

const mutations = {
  setAll(state, object) {
    state.all = object;
  },
  setSingle(state, object) {
    state.single = object;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
